import PKCE from 'js-pkce';
import Cookies from 'js-cookie';


const element = document.getElementById("age-verify")
let shieldAPI = element.getAttribute('data-api') || "https://api.ageshield.app";
let blurpx = element.getAttribute('data-blurpx') || '5px';
const cookiepath = element.getAttribute('data-path') || '/';
const cookieExpire = Number.parseInt(element.getAttribute('data-expiration') || '30');
const analytics = createAnalytics();
loadAnalyticsEnv();
let redirect_uri = localStorage.getItem('age-verify-redirect_uri')
if (!redirect_uri) {
    let redirect_uri_temp = URL.parse(window.location.href)
    redirect_uri_temp.searchParams.set("age_verify_redirect", "")
    redirect_uri = redirect_uri_temp.toString()
    localStorage.setItem('age-verify-redirect_uri', redirect_uri)
}
const pkce = new PKCE({
    client_id: element.getAttribute('data-cid'),
    redirect_uri: redirect_uri,
    authorization_endpoint: shieldAPI + '/authorize',
    token_endpoint: shieldAPI + '/token',
    revoke_endpoint: shieldAPI + '/revoke', // optional
    requested_scopes: '*',
    storage: localStorage // optional
});
pkce.enableCorsCredentials(true);
// Tamaño de la ventana popup (configurable desde el HTML con data-popup-width / data-popup-height)
const popupWidth = parseInt(element.getAttribute('data-popup-width')) || 900;
const popupHeight = parseInt(element.getAttribute('data-popup-height')) || 900;
let ageVerified = !!Cookies.get('ageVerified')
let onRedirect = URL.parse(window.location.href).searchParams.has("age_verify_redirect")

function createAnalytics() {
    const DEFAULT_ENDPOINT = 'https://landingmetrics.tech555.dev';
    const DEVICE_KEY = 'ageshield_analytics_device_id';
    const TRAFFIC_KEY = 'ageshield_analytics_traffic_context';
    const VARIANTS_KEY = 'ageshield_analytics_variants';
    const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
    const viewTimes = [];
    let ready = false;
    const queue = [];

    function storageGet(key) {
        try { return localStorage.getItem(key); } catch (e) { return null; }
    }

    function storageSet(key, value) {
        try { localStorage.setItem(key, value); } catch (e) {}
    }

    function parseJSON(value, fallback) {
        if (!value) return fallback;
        try { return JSON.parse(value); } catch (e) { return fallback; }
    }

    function env() {
        return window.__env__ || {};
    }

    function endpoint() {
        return element.getAttribute('data-analytics-endpoint') || env().ANALYTICS_ENDPOINT || DEFAULT_ENDPOINT;
    }

    function enabled() {
        const attrEnabled = element.getAttribute('data-enable-analytics') || element.getAttribute('data-analytics-enabled');
        return attrEnabled === 'true' || env().ENABLE_ANALYTICS === 'true';
    }

    function deviceId() {
        let id = storageGet(DEVICE_KEY);
        if (id) return id;
        const random = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
        id = `device-${random}`;
        storageSet(DEVICE_KEY, id);
        return id;
    }

    function trafficContext() {
        const cached = parseJSON(storageGet(TRAFFIC_KEY), null);
        if (cached) return cached;
        const params = new URLSearchParams(window.location.search);
        const context = {};
        UTM_KEYS.forEach((key) => {
            const value = params.get(key);
            if (value) context[key] = value;
        });
        const country = params.get('country');
        if (country) context.country = country;
        if (Object.keys(context).length > 0) storageSet(TRAFFIC_KEY, JSON.stringify(context));
        return context;
    }

    function variantsContext() {
        const params = new URLSearchParams(window.location.search);
        const context = Object.assign({}, parseJSON(storageGet(VARIANTS_KEY), {}));
        const experimentId = params.get('experiment_id');
        const variantId = params.get('variant_id');
        const variants = params.get('variants');
        if (experimentId) context.experiment_id = experimentId;
        if (variantId) context.variant_id = variantId;
        if (variants) context.variants = variants.split(',').map((variant) => variant.trim()).filter(Boolean);
        if (Object.keys(context).length > 0) storageSet(VARIANTS_KEY, JSON.stringify(context));
        return context;
    }

    function enrich(metadata) {
        return Object.assign(
            {},
            variantsContext(),
            trafficContext(),
            { device_id: deviceId(), client_id: element.getAttribute('data-cid') || '', shield_api: shieldAPI },
            metadata || {}
        );
    }

    function sendNow(type, offerSlug, metadata, keepalive) {
        if (!enabled()) return;
        const enriched = enrich(Object.assign({}, metadata || {}, { offer_slug: offerSlug }));
        const payload = {
            type,
            uuid: deviceId(),
            page: window.location.href,
            device: navigator.userAgent || '',
            country: enriched.country || '',
            metadata: JSON.stringify(enriched)
        };
        fetch(`${endpoint().replace(/\/$/, '')}/log`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
            keepalive: !!keepalive
        }).catch((error) => console.error('[analytics] failed to send event', error));
    }

    function send(type, offerSlug, metadata, keepalive) {
        if (!ready) {
            queue.push([type, offerSlug, metadata, keepalive]);
            return;
        }
        sendNow(type, offerSlug, metadata, keepalive);
    }

    function flushViewTimes() {
        while (viewTimes.length) {
            const entry = viewTimes.shift();
            const now = window.performance && window.performance.now ? window.performance.now() : Date.now();
            sendNow('view_time', `${entry.step}_view_time`, Object.assign({}, entry.metadata, {
                action: 'view_time',
                step: entry.step,
                duration_seconds: Number(((now - entry.startedAt) / 1000).toFixed(2))
            }), true);
        }
    }

    window.addEventListener('pagehide', flushViewTimes);
    window.addEventListener('beforeunload', flushViewTimes);
    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'hidden') flushViewTimes();
    });

    return {
        markReady() {
            ready = true;
            while (queue.length) sendNow(...queue.shift());
        },
        event(offerSlug, metadata) {
            send('event', offerSlug, metadata);
        },
        click(offerSlug, metadata) {
            send('click', offerSlug, Object.assign({ action: 'click' }, metadata || {}));
        },
        stepView(step, metadata) {
            const startedAt = window.performance && window.performance.now ? window.performance.now() : Date.now();
            send('view', `${step}_view`, Object.assign({ action: 'page_view', step }, metadata || {}));
            viewTimes.push({ step, metadata: Object.assign({}, metadata || {}), startedAt });
        }
    };
}

function loadAnalyticsEnv() {
    return new Promise((resolve) => {
        let resolved = false;
        const done = () => {
            if (resolved) return;
            resolved = true;
            analytics.markReady();
            resolve();
        };
        if (window.__env__ || element.getAttribute('data-enable-analytics') || element.getAttribute('data-analytics-enabled')) {
            done();
            return;
        }
        const script = document.createElement('script');
        script.src = `${shieldAPI.replace(/\/$/, '')}/static/env-config.js`;
        script.onload = done;
        script.onerror = done;
        setTimeout(done, 1500);
        document.head.appendChild(script);
    });
}

// whenBodyReady runs fn once <body> exists. The script may be loaded
// synchronously in <head>, which is what keeps the page from showing before
// the age wall: the styles go in at once, the DOM work waits for the body.
function whenBodyReady(fn) {
    if (document.body) {
        fn();
        return;
    }
    document.addEventListener('DOMContentLoaded', fn, { once: true });
}

function applyBlurEffect() {
    const style = document.createElement('style');
    style.id = 'age-verify-blur';
    style.textContent = `
        body > *:not(.age-verify-modal) {
            filter: blur(${blurpx}) !important;
            -webkit-filter: blur(${blurpx}) !important;
            pointer-events: none !important;
        }
        .age-verify-modal {
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            width: 100vw !important;
            height: 100dvh !important;
            background: rgba(0, 0, 0, 0.8) !important;
            display: flex !important;
            justify-content: center !important;
            align-items: center !important;
            z-index: 10000 !important;
            pointer-events: auto !important;
            filter: none !important;
            -webkit-filter: none !important;
            padding: 16px !important;
            box-sizing: border-box !important;
        }
        .age-verify-modal iframe {
            width: 500px !important;
            height: 700px !important;
            border: none !important;
            border-radius: 15px !important;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3) !important;
            background: white !important;
            filter: none !important;
            -webkit-filter: none !important;
        }
        .age-verify-spinner {
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            width: 100vw !important;
            height: 100vh !important;
            background: #667eea !important;
            display: flex !important;
            flex-direction: column !important;
            justify-content: center !important;
            align-items: center !important;
            z-index: 10001 !important;
        }
        .age-verify-spinner .spinner {
            width: 50px !important;
            height: 50px !important;
            border: 4px solid rgba(255, 255, 255, 0.3) !important;
            border-top: 4px solid white !important;
            border-radius: 50% !important;
            animation: spin 1s linear infinite !important;
            margin-bottom: 20px !important;
        }
        .age-verify-spinner p {
            color: white !important;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;
            font-size: 18px !important;
        }
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
    `;
    document.head.appendChild(style);
}

function showSpinner() {
    // Styles first, so the site never paints while the body is parsed.
    const style = document.createElement('style');
    style.id = 'age-verify-spinner-style';
    style.textContent = `
        body > *:not(.age-verify-spinner):not([role="status"]) {
            display: none !important;
        }
        .age-verify-spinner {
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            width: 100vw !important;
            height: 100vh !important;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
            display: flex !important;
            flex-direction: column !important;
            justify-content: center !important;
            align-items: center !important;
            z-index: 10001 !important;
        }
        .age-verify-spinner .spinner {
            width: 50px !important;
            height: 50px !important;
            border: 4px solid rgba(255, 255, 255, 0.3) !important;
            border-top: 4px solid white !important;
            border-radius: 50% !important;
            animation: spin 1s linear infinite !important;
            margin-bottom: 20px !important;
        }
        .age-verify-spinner p {
            color: white !important;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif !important;
            font-size: 18px !important;
        }
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
    `;
    document.head.appendChild(style);

    whenBodyReady(() => {
        // Hide all body content
        document.body.innerHTML = '';

        // Create spinner overlay
        const spinner = document.createElement('div');
        spinner.id = 'age-verify-spinner';
        spinner.className = 'age-verify-spinner';
        spinner.innerHTML = `
            <div class="spinner"></div>
            <p>Verifying your age...</p>
        `;
        document.body.appendChild(spinner);
    });
}

let messageListener = null;
let clickListener = null;
let storageListener = null;
let pollInterval = null;
let verificationHandled = false;
let visibilityListener = null;
let focusListener = null;

function removeBlurEffect() {
    const blurStyle = document.getElementById('age-verify-blur');
    if (blurStyle) {
        blurStyle.remove();
    }

    const modal = document.getElementById('age-verify-modal');
    if (modal) {
        modal.remove();
    }

    if (messageListener) {
        window.removeEventListener('message', messageListener);
        messageListener = null;
    }

    if (storageListener) {
        window.removeEventListener('storage', storageListener);
        storageListener = null;
    }

    // Remove visibility/focus listeners
    try {
        if (visibilityListener) {
            document.removeEventListener('visibilitychange', visibilityListener);
            visibilityListener = null;
        }
        if (focusListener) {
            window.removeEventListener('focus', focusListener);
            focusListener = null;
        }
    } catch (e) {}

    // Close broadcast channel if present
    try {
        if (window._ageVerifyBroadcast) {
            try { window._ageVerifyBroadcast.close(); } catch (e) {}
            window._ageVerifyBroadcast = null;
        }
    } catch (e) {}

    if (clickListener) {
        document.removeEventListener('click', clickListener);
        clickListener = null;
    }

    if (pollInterval) {
        clearInterval(pollInterval);
        pollInterval = null;
    }
}

// Centralized handler to run when verification is detected (message, storage event or polling)
async function handleSuccessfulVerification(popupWindowRef) {
    if (verificationHandled) return;
    verificationHandled = true;
    analytics.event('embedded_verification_completed', {
        action: 'verification_completed',
        source: 'message_or_poll'
    });

    // Try to get token from localStorage
    const token = localStorage.getItem('age_verify_token');
    if (token) {
        try {
            const resp = await fetch(shieldAPI + '/age', {
                headers: { Authorization: `Bearer ${token}` }
            });
            if (resp.status === 200) {
                const json = await resp.json();
                if (json.verified) {
                    Cookies.set('ageVerified', json.id, {expires: cookieExpire, path: cookiepath});
                    ageVerified = true;
                }
            }
        } catch (err) {
            console.error('Error verifying age after popup/storage:', err);
        }
    } else {
        // As fallback, check for cookie
        if (Cookies.get('ageVerified')) {
            ageVerified = true;
        }
    }

    // Close popup if it exists and was opened by us
    try {
        const pw = popupWindowRef || window._ageVerifyPopup;
        if (pw && !pw.closed) pw.close();
    } catch (e) {}

    // Close broadcast channel if present
    try {
        if (window._ageVerifyBroadcast) {
            try { window._ageVerifyBroadcast.close(); } catch (e) {}
            window._ageVerifyBroadcast = null;
        }
    } catch (e) {}

    // Remove modal and blur
    removeBlurEffect();
}

// callbackContext says where the OAuth callback page is running: in the
// popup the age wall opened, in an iframe, or in the site's own tab (no
// popup: it was blocked, or the browser opened the flow in the same tab).
function callbackContext() {
    try {
        if (window.opener && !window.opener.closed) return 'popup';
    } catch (e) {}
    if (window.parent && window.parent !== window) return 'iframe';
    return 'tab';
}

// cleanCallbackURL is this page without the OAuth callback query, so loading
// it does not run the callback again.
function cleanCallbackURL() {
    const url = new URL(window.location.href);
    ['age_verify_redirect', 'code', 'state', 'error', 'error_description', 'error_uri', 'iss'].forEach((key) => {
        url.searchParams.delete(key);
    });
    return url.toString();
}

// finishCallback ends the OAuth callback. The spinner has emptied the page,
// so it must never stay: a popup tells its opener and closes, an iframe tells
// its parent, and the site's own tab reloads without the callback query (the
// site then opens unlocked, or shows the age wall again after a failure).
function finishCallback(verified) {
    const where = callbackContext();
    if (where === 'tab') {
        window.location.replace(cleanCallbackURL());
        return;
    }
    const target = where === 'popup' ? window.opener : window.parent;
    try {
        target.postMessage(verified ? 'age_verified' : 'age_verify_error', '*');
    } catch (e) {}
    if (where === 'popup') {
        window.close();
        // window.close is refused when the browser no longer treats this
        // window as script-opened; leave a way back instead of a spinner.
        setTimeout(() => showCallbackDone(verified), 600);
        return;
    }
    showCallbackDone(verified);
}

// showCallbackDone replaces the spinner with the outcome and a link back to
// the site, in the page's language (Spanish or English).
function showCallbackDone(verified) {
    const lang = (document.documentElement.lang || navigator.language || 'en').toLowerCase();
    const es = lang.indexOf('es') === 0;
    const text = verified
        ? (es ? ['Edad verificada', 'Ya puedes cerrar esta ventana.'] : ['Age verified', 'You can close this window now.'])
        : (es ? ['No se ha podido completar', 'Vuelve a la web e inténtalo de nuevo.'] : ["We couldn't finish", 'Go back to the site and try again.']);
    try {
        document.getElementById('age-verify-spinner')?.remove();
        const box = document.createElement('div');
        box.setAttribute('role', 'status');
        box.style.cssText = 'position:fixed;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:12px;padding:24px;text-align:center;background:oklch(0.975 0.007 95);color:oklch(0.24 0.02 165);font-family:ui-sans-serif,system-ui,-apple-system,"Segoe UI",sans-serif;z-index:2147483647';
        const title = document.createElement('h2');
        title.textContent = text[0];
        title.style.cssText = 'margin:0;font-size:24px;font-weight:600;letter-spacing:-0.01em';
        const body = document.createElement('p');
        body.textContent = text[1];
        body.style.cssText = 'margin:0;font-size:16px;color:oklch(0.46 0.018 165)';
        const back = document.createElement('a');
        back.href = cleanCallbackURL();
        back.textContent = es ? 'Volver a la web' : 'Back to the site';
        back.style.cssText = 'margin-top:8px;display:inline-flex;align-items:center;justify-content:center;min-height:48px;padding:0 20px;border-radius:12px;background:oklch(0.43 0.085 165);color:oklch(0.993 0.004 95);font-weight:600;text-decoration:none';
        box.append(title, body, back);
        whenBodyReady(() => document.body.appendChild(box));
    } catch (e) {}
}

if (onRedirect) {
    analytics.stepView('embedded_oauth_callback', {
        step: 'oauth_callback',
        has_action: true
    });
    showSpinner()
    const url = window.location.href;
    pkce.exchangeForAccessToken(url)
        .then((resp) => {
            const token = resp.access_token;
            analytics.event('embedded_oauth_token_received', {
                action: 'oauth_token_received'
            });
            localStorage.setItem('age_verify_token', token);
            localStorage.setItem('age_verify_refresh', resp.refresh_token);
            // Signal other tabs/windows that verification completed
            try { localStorage.setItem('age_verify_complete', Date.now().toString()); } catch (e) {}

            return fetch(shieldAPI + '/age', {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then((response) => {
                if (response.status === 200) {
                    return response.json();
                }
            }).then((json) => {
                if (!json || !json.verified) {
                    throw new Error('age not verified');
                }
                analytics.event('embedded_oauth_age_verified', {
                    action: 'oauth_age_verified'
                });
                Cookies.set('ageVerified', json.id, {expires: cookieExpire, path: cookiepath});
                ageVerified = true;

                // Also notify other tabs via localStorage flag and BroadcastChannel
                try { localStorage.setItem('age_verify_complete', Date.now().toString()); } catch (e) {}
                try {
                    if (typeof BroadcastChannel !== 'undefined') {
                        const bc = new BroadcastChannel('age_verify');
                        bc.postMessage('age_verified');
                        bc.close();
                    }
                } catch (e) {}

                finishCallback(true);
            })
        }).catch((err) => {
        console.error(err);
        analytics.event('embedded_oauth_callback_failed', {
            action: 'oauth_callback_failed',
            // js-pkce rejects with {error} (e.g. access_denied, Invalid State).
            error_message: err && (err.message || err.error) ? (err.message || err.error) : ''
        });
        finishCallback(false);
    })
} else {
    if (!ageVerified) {
        analytics.stepView('embedded_age_gate', {
            step: 'age_gate_modal',
            has_action: false
        });
        applyBlurEffect();

        // Create modal overlay (simple prompt with a button that opens a popup)
        const modal = document.createElement('div');
        modal.id = 'age-verify-modal';
        modal.className = 'age-verify-modal';

        const container = document.createElement('div');
        container.style.display = 'flex';
        container.style.flexDirection = 'column';
        container.style.alignItems = 'center';
        container.style.gap = '16px';

        const title = document.createElement('h2');
        title.textContent = 'Verify your age';
        title.style.color = '#fff';

        const info = document.createElement('p');
        info.textContent = 'Click the button below to open the verification provider in a popup window.';
        info.style.color = '#ddd';
        info.style.maxWidth = '400px';
        info.style.textAlign = 'center';

        const btn = document.createElement('button');
        btn.id = 'age-verify-open-popup';
        btn.textContent = 'Start verification';
        btn.style.padding = '18px 26px';
        btn.style.borderRadius = '6px';
        btn.style.border = 'none';
        btn.style.background = '#4F46E5';
        btn.style.color = 'white';
        btn.style.cursor = 'pointer';
        btn.style.fontSize = '16px';
        btn.style.fontWeight = 'bold';

        const isDesktopViewport = window.matchMedia('(min-width: 768px)').matches;
        let popupOpenedState = false;

        function setPopupOpenedState() {
            if (!isDesktopViewport || popupOpenedState) return;
            popupOpenedState = true;
            title.textContent = 'Verification window is open';
            info.textContent = 'If you opened your email app, click below to bring the verification window back.';
            btn.textContent = 'Return to verification';
            btn.setAttribute('aria-label', 'Return to verification window');
        }

        container.appendChild(title);
        container.appendChild(info);
        container.appendChild(btn);
        modal.appendChild(container);
        // Verification may already have been detected (another tab) before
        // the body was parsed; then the wall must not come back.
        whenBodyReady(() => {
            if (!verificationHandled) document.body.appendChild(modal);
        });

        // Popup window reference
        let popupWindow = null;

        // store popup ref globally in case storage event triggers and we want to close it
        window._ageVerifyPopup = null;

        // Message listener that will be used to receive messages from popup
        messageListener = async (event) => {
            if (!event || !event.data) return;
            if (event.data === 'age_verified') {
                await handleSuccessfulVerification(popupWindow);
            } else if (event.data === 'age_verify_error') {
                console.log('age_verify-error');
                analytics.event('embedded_verification_error_message', {
                    action: 'verification_error_message'
                });
                try {
                    if (popupWindow && !popupWindow.closed) popupWindow.close();
                } catch (e) {}
                window.location.reload();
            }
        };
        window.addEventListener('message', messageListener);

        // Storage listener to catch localStorage changes from other tabs (mobile new-tab case)
        storageListener = (e) => {
            if (!e) return;
            if (e.key === 'age_verify_token' || e.key === 'age_verify_complete' || e.key === 'ageVerified') {
                // token or completion flag set in another tab
                handleSuccessfulVerification(popupWindow);
            }
        };
        window.addEventListener('storage', storageListener);

        // Visibility / focus listeners to detect when user returns to this tab (mobile behavior)
        visibilityListener = () => {
            if (document.visibilityState === 'visible') {
                if (Cookies.get('ageVerified') || localStorage.getItem('age_verify_token') || localStorage.getItem('age_verify_complete')) {
                    handleSuccessfulVerification(window._ageVerifyPopup);
                }
            }
        };
        document.addEventListener('visibilitychange', visibilityListener);

        focusListener = () => {
            if (Cookies.get('ageVerified') || localStorage.getItem('age_verify_token') || localStorage.getItem('age_verify_complete')) {
                handleSuccessfulVerification(window._ageVerifyPopup);
            }
        };
        window.addEventListener('focus', focusListener);

        // BroadcastChannel listener for reliable cross-tab notification
        let bcListener = null;
        try {
            if (typeof BroadcastChannel !== 'undefined') {
                const bc = new BroadcastChannel('age_verify');
                bcListener = (msg) => {
                    if (msg && msg.data === 'age_verified') {
                        handleSuccessfulVerification(popupWindow);
                        try { bc.close(); } catch (e) {}
                    }
                };
                bc.addEventListener('message', bcListener);
                // store reference so we can close later
                window._ageVerifyBroadcast = bc;
            }
        } catch (e) {}

        // Polling fallback for browsers that don't reliably fire storage events to the originating tab
        pollInterval = setInterval(() => {
            if (Cookies.get('ageVerified') || localStorage.getItem('age_verify_token') || localStorage.getItem('age_verify_complete')) {
                handleSuccessfulVerification(popupWindow);
            }
        }, 1000);

        // Click handler to open the popup
        clickListener = (e) => {
            if (e.target && (e.target === btn || e.target.id === 'age-verify-open-popup')) {
                if (popupWindow && !popupWindow.closed) {
                    analytics.click('embedded_age_gate_popup_refocus_click', {
                        step: 'age_gate_modal',
                        action: 'popup_refocus',
                        has_action: true
                    });
                    try { popupWindow.focus(); } catch (err) {}
                    setPopupOpenedState();
                    return;
                }

                analytics.click('embedded_age_gate_start_click', {
                    step: 'age_gate_modal',
                    action: 'start_verification',
                    has_action: true
                });
                // Open popup centered
                const w = popupWidth; const h = popupHeight;
                const left = window.screenX + ((window.outerWidth - w) / 2);
                const top = window.screenY + ((window.outerHeight - h) / 2);
                const authorizeUrl = pkce.authorizeUrl();
                popupWindow = window.open(authorizeUrl, 'age_verify_popup', `width=${w},height=${h},left=${left},top=${top}`);
                // Save globally so storage event handler can access
                window._ageVerifyPopup = popupWindow;
                if (popupWindow) {
                    analytics.event('embedded_age_gate_popup_opened', {
                        action: 'popup_opened',
                        popup_width: w,
                        popup_height: h
                    });
                    setPopupOpenedState();
                    try { popupWindow.focus(); } catch (e) {}
                } else {
                    analytics.event('embedded_age_gate_popup_blocked', {
                        action: 'popup_blocked'
                    });
                    // popup blocked or opened in new tab — still set window._ageVerifyPopup to null
                    window._ageVerifyPopup = null;
                    // fallback to opening in same tab
                    window.location.href = authorizeUrl;
                }
            }
        };
        document.addEventListener('click', clickListener);
    } else {
        analytics.event('embedded_age_gate_already_verified', {
            action: 'already_verified'
        });
    }
}
